const env = {
    apiUrl: process.env.REACT_APP_API_URL,
    META_APP_ID: process.env.REACT_APP_META_APP_ID,
    META_APP_REDIRECT_URI: process.env.REACT_APP_META_APP_REDIRECT_URI,
};

export default env;
